import { Message } from "primereact/message";

import { ErrorState, StateMessage } from "@/ds";
import { CARREGANDO_LABEL } from "./cartao-financeiro-transferencia.constants";
import styles from "./cartao-financeiro-transferencia.module.scss";
import type { CartaoFinanceiroTransferenciaViewModel } from "./types-cartao-financeiro-transferencia";

export function CartaoFinanceiroTransferenciaView({
  estado,
  errorMessage,
  recarregar,
  valores,
  cotacao,
  alertasCotacao,
}: CartaoFinanceiroTransferenciaViewModel) {
  if (estado === "carregando") {
    return (
      <StateMessage
        variant="loading"
        title={CARREGANDO_LABEL}
        testId="transferir-financeiro-loading"
      />
    );
  }
  if (estado === "erro") {
    return (
      <ErrorState
        message={errorMessage ?? undefined}
        onRetry={recarregar}
        testId="transferir-financeiro-erro"
      />
    );
  }

  return (
    <section className={styles.cartao} data-testid="transferir-financeiro">
      <dl className={styles.valores}>
        {valores.map(({ chave, testId, rotulo, valor }) => (
          <div key={chave} className={styles.valor}>
            <dt className={styles.rotulo}>{rotulo}</dt>
            <dd className={styles.numero} data-testid={testId}>
              {valor}
            </dd>
          </div>
        ))}
      </dl>
      {cotacao ? (
        <p className={styles.cotacao} data-testid="transferir-financeiro-cotacao">
          {cotacao}
        </p>
      ) : null}
      {alertasCotacao.map((alerta) => (
        <Message
          key={alerta}
          className="p-message-block"
          severity="warn"
          text={alerta}
          data-testid="transferir-financeiro-sem-cotacao"
        />
      ))}
    </section>
  );
}
